/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { memo } from 'react';

import { sortBy } from 'lodash';

import PartnerBox from 'bundles/partners-graphql/components/listing/PartnerBox';
import type { PartnerListingPagePartnerFragment as PartnerListingPagePartner } from 'bundles/partners-graphql/queries/__generated__/GetAllPartners';

type PropsToComponent = {
  partners: Array<PartnerListingPagePartner>;
  selectedCountry?: string;
};

const styles = {
  wrapper: css`
    margin: 30px 0;
  `,
};

const PartnerBoxes = ({ partners, selectedCountry }: PropsToComponent) => {
  const getAlphabeticallyOrderedPartners = () => {
    let filteredPartners;

    // Filter out partners without logo or link
    filteredPartners = partners.filter(
      ({ slug, homePageOverride, squareLogo }) => !!squareLogo && (!!slug || !!homePageOverride)
    );

    if (selectedCountry) {
      filteredPartners = filteredPartners.filter(
        (partner) => partner?.location?.country?.toLowerCase() === selectedCountry.toLowerCase()
      );
    }

    const sortedPartners: Array<PartnerListingPagePartner> = sortBy(filteredPartners, function (partner) {
      return partner?.name?.toLowerCase();
    });

    return sortedPartners;
  };

  return (
    <div css={styles.wrapper} className="horizontal-box wrap" data-e2e="partner-boxes">
      {getAlphabeticallyOrderedPartners().map((partner) => {
        return <PartnerBox key={partner.id} partner={partner} />;
      })}
    </div>
  );
};

export default memo(PartnerBoxes);
